import React, { lazy } from "react";
import filesize from "filesize";
import { LoadingState } from "components/Shared";

const PDF = lazy(() => import("react-pdf-js"))

export default class PDFViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      scale: 0.8,
      rotate: 0
    };
  }

  onDocumentComplete(pages) {
    this.setState({ page: 1, pages });
  }

  onPageComplete(page) {
    this.setState({ page });
  }

  doRotate(event) {
    event.preventDefault();
    const state = this.state;
    state.rotate += 90;
    this.setState(state);
  }

  goBack() {
    this.setState({ page: this.state.page - 1 });
  }

  goNext() {
    this.setState({ page: this.state.page + 1 });
  }

  renderPagination(page, pages) {
    return (
      <nav>
        <ul className="pager">
          {page === 1 ? (
            <li />
          ) : (
            <li className="previous">
              <a href="#previous" onClick={event => this.goBack(event)}>
                <i className="fas fa-angle-left" /> Previous
              </a>
            </li>
          )}
          <li>
            Page {this.state.page}/{pages}{" "}
            <a id="rotate" href="#rotate" onClick={event => this.doRotate(event)}>
              <i className="fas fa-fw fa-redo" />
            </a>
          </li>
          {page === pages ? (
            <li />
          ) : (
            <li className="next">
              <a href="#next" onClick={event => this.goNext(event)}>
                Next <i className="fas fa-angle-right" />
              </a>
            </li>
          )}
        </ul>
      </nav>
    );
  }

  render() {
    const { signed_uri, name, filesize_bytes } = this.props;
    const { scale, rotate, page, pages } = this.state;
    return (
      <div className="pdf-viewer">
        {pages && pages >= 1 && this.renderPagination(page, pages)}
        <section>
          <PDF
            file={signed_uri}
            loading={
              <LoadingState>
                <p>
                  Retrieving {name ? name : "PDF File"}{" "}
                  {!!filesize_bytes && filesize(filesize_bytes) && `(${filesize(filesize_bytes)})`}
                </p>
              </LoadingState>
            }
            onDocumentComplete={pages => this.onDocumentComplete(pages)}
            onPageComplete={page => this.onPageComplete(page)}
            scale={scale}
            rotate={rotate}
            page={page}
          />
        </section>
      </div>
    );
  }
}
